<template>

<div class="padded">
  <div class="dash-heading"><i class="fa fa-share-alt" />&nbsp;Requests by Sharers</div>

  <el-table :data="data" :cell-class-name="cellClass" :header-cell-class-name="cellClass">
    <el-table-column prop="shortName" label="Name" fixed />
    <el-table-column label="RTA" align="center">
      <el-table-column prop="rta" label="Active" align="center" />
      <el-table-column prop="rtaRejected" label="Rejected" align="center" />
      <el-table-column prop="rtaClosed" label="Closed" align="center" />
    </el-table-column>

    <el-table-column label="RTS" align="center">
      <el-table-column prop="rts" label="Active" align="center" />
      <el-table-column prop="rtsRejected" label="Rejected" align="center" />
      <el-table-column prop="rtsClosed" label="Closed" align="center" />
    </el-table-column>

    <el-table-column label="RTU" align="center">
      <el-table-column prop="rtu" label="Active" align="center" />
      <el-table-column prop="rtuRejected" label="Rejected" align="center" />
      <el-table-column prop="rtuClosed" label="Closed" align="center" />
    </el-table-column>

    <el-table-column label="RTB" align="center">
      <el-table-column prop="rtb" label="Active" align="center" />
      <el-table-column prop="rtbRejected" label="Rejected" align="center" />
      <el-table-column prop="rtbClosed" label="Closed" align="center" />
    </el-table-column>

    <el-table-column label="RTD" align="center">
      <el-table-column prop="rtd" label="Active" align="center" />
      <el-table-column prop="rtdRejected" label="Rejected" align="center" />
      <el-table-column prop="rtdClosed" label="Closed" align="center" />
    </el-table-column>


  </el-table>
</div>

</template>

<script>

import PostMixins from '@/mixins/PostMixins'
import ElTableMixins from '@/mixins/ElTableMixins'
import NumberMixins from '@/mixins/NumberMixins'

// import {chartColors} from '@/components/Data'
import {VFrappeChart} from 'vue-frappe-chart'

export default {
  mixins: [PostMixins, ElTableMixins, NumberMixins],

  components: {
    VFrappeChart
  },

  methods: {
    cellClass ({row, column, rowIndex, columnIndex}) {

//      console.log(column.label, rowIndex, columnIndex)

      if (column.label === 'RTA') {
        return 'bg-warning-lighten-1'
      }

      if (column.label === 'Active') {
        return 'bg-primary-lighten-1'
      }

      if (column.label === 'Rejected') {
        return 'bg-warning-lighten-2'
      }

      if (column.label === 'Closed') {
        return 'bg-success-lighten-2'
      }

    },

    successReport (data) {
      this.data = data
    }
  },

  data () {
    return {
      data: [],
      labels: []
    }
  },

  created () {
    this.fetchData('/stats/org/30/null/telco', this.successReport, 'Requests by Sharers Report')
  }

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// SummaryRequests.vue?55cefe0a